import request from '@/utils/request';
import type { GoalStats, GoalAchievements } from './types';

export function extractPayload<T>(data: unknown): T {
  if (Array.isArray(data)) {
    return data as T;
  }
  if (data && typeof data === 'object' && 'payload' in data) {
    return (data as { payload: T }).payload;
  }
  return data as T;
}

function extractApiError(error: unknown, fallback: string): string {
  const err = error as { response?: { data?: { errors?: Array<{ message?: string; description?: string }> } }; message?: string };
  if (err.response?.data?.errors && Array.isArray(err.response.data.errors) && err.response.data.errors.length > 0) {
    return err.response.data.errors[0].message || err.response.data.errors[0].description || fallback;
  }
  return err.message || fallback;
}

export async function getGoalDashboardStats(): Promise<GoalStats> {
  try {
    const response = await request.get(`Goals/dashboard/stats`);
    return extractPayload<GoalStats>(response.data);
  } catch (error: unknown) {
    throw new Error(extractApiError(error, 'Failed to fetch goal dashboard statistics'));
  }
}

export async function getGoalProgressIndicators(): Promise<unknown[]> {
  try {
    const response = await request.get(`Goals/dashboard/progress-indicators`);
    return extractPayload<unknown[]>(response.data);
  } catch (error: unknown) {
    throw new Error(extractApiError(error, 'Failed to fetch goal progress indicators'));
  }
}

export async function getSurveyDashboardData(): Promise<Record<string, unknown>> {
  try {
    const response = await request.get(`Survey/GetStats`);
    return extractPayload<Record<string, unknown>>(response.data);
  } catch (error: unknown) {
    throw new Error(extractApiError(error, 'Failed to fetch survey data'));
  }
}

export async function getGoalAchievementProgress(): Promise<GoalAchievements> {
  try {
    const response = await request.get(`Goals/achievements/progress`);
    return extractPayload<GoalAchievements>(response.data);
  } catch (error: unknown) {
    throw new Error(extractApiError(error, 'Failed to fetch goal achievement progress'));
  }
}
